<template>
  <v-dialog v-model="newMatFormIsOpen" width="99%" max-width="900">
    <v-card color="#F5F5F5">
      <v-col align="center" style="font-weight: bold; font-size: 17px">
        Ajouter un materiel
      </v-col>
      <v-col>
        <v-col cols="12" class="pa-1">
          <v-card variant="flat" style="border: solid 1px lightgrey">
            <v-combobox
              bg-color="white"
              class="edition"
              v-model="materiel['family']"
              return-object
              item-title="Nom_Famille_Principale"
              :items="familyListe"
              hide-details
              label="Famille"
            >
            </v-combobox>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-1" v-if="materiel['family']">
          <v-card variant="flat" style="border: solid 1px lightgrey">
            <v-combobox
              bg-color="white"
              class="edition"
              @update:modelValue="changeSubFamily"
              v-model="materiel['subFamily']"
              return-object
              item-title="fieldData.Nom_Genre_Machine"
              :items="
                subFamilyListe.filter(
                  (val) =>
                    val.fieldData['Famille Parc'] ==
                    materiel['family']['Nom_Famille_Principale']
                )
              "
              hide-details
              label="Sous famille"
            >
            </v-combobox>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-1" v-if="materiel['subFamily']">
          <v-card variant="flat" style="border: solid 1px lightgrey">
            <v-combobox
              bg-color="white"
              class="edition"
              v-model="materiel['materiel']"
              return-object
              item-title="MATRICULE"
              :items="
                parcListe.filter(
                  (val) =>
                    val.SOUS_FAMILLE ==
                    materiel['subFamily'].fieldData['Nom_Genre_Machine']
                )
              "
              hide-details
              label="Matricule"
              @update:modelValue="matriculeChange(materiel)"
            >
            </v-combobox>
          </v-card>
          <v-col
            v-if="
              materiel['materiel'] && matriculIsFree[materiel['materiel'].MATRICULE_UID]
            "
            class="pb-0"
          >
            <div
              v-if="
                matriculIsFree[materiel['materiel'].MATRICULE_UID].data.disponible ==
                'false'
              "
            >
              <v-chip style="background-color: red; color: white; font-weight: bold">
                Le {{ materiel["materiel"].MATRICULE }}
                n'est pas disponible
              </v-chip>
            </div>
            <div
              v-if="
                matriculIsFree[materiel['materiel'].MATRICULE_UID].data.disponible ==
                'true'
              "
            >
              <v-chip style="background-color: green; color: white; font-weight: bold">
                Le
                {{ materiel["materiel"].MATRICULE }}
                est disponible
              </v-chip>
            </div>
          </v-col>
          <v-col v-if="selectedSubFamilyData && materiel['materiel']" class="px-0 pt-3">
            <v-card variant="flat" style="border: solid 1px lightgrey">
              <v-combobox
                label="Type de location"
                v-model="materiel['subscription']"
                class="edition"
                bg-color="white"
                hide-details
                :items="selectedSubFamilyData.portalData.CAT_Tarif_GM_id"
                return-object
                item-title="CAT_Tarif_GM_id::Nom_Grille"
              >
              </v-combobox>
            </v-card>
          </v-col>
          <v-col v-if="materiel['subscription']" class="px-0">
            <v-card align="left" variant="flat" style="border: solid 1px lightgrey">
              <v-col>
                <div>
                  {{ materiel["subscription"]["CAT_Tarif_GM_id::T1_Tarif"] }}€ :
                  <span
                    v-html="
                      materiel['subscription']['CAT_Tarif_nom_id::libelle_plein'].replace(
                        /@@(.*?)@@/g,
                        '<b>$1</b>'
                      )
                    "
                  ></span>
                </div>
                <div v-if="materiel['subscription']['CAT_Tarif_GM_id::T2_Tarif']">
                  <br />
                  {{ materiel["subscription"]["CAT_Tarif_GM_id::T2_Tarif"] }}€ :
                  <span
                    v-html="
                      materiel['subscription'][
                        'CAT_Tarif_nom_id::libelle_reduit'
                      ].replace(/@@(.*?)@@/g, '<b>$1</b>')
                    "
                  ></span>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <v-col class="px-0">
            <v-card variant="flat" style="border: solid 1px lightgrey">
              <v-select
                bg-color="white"
                return-object
                v-if="
                  materiel['subscription'] &&
                  materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'] != undefined
                "
                label="Tarif"
                v-model="materiel['price']"
                :items="
                  materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'] != undefined &&
                  materiel['subscription']['CAT_Tarif_GM_id::T2_Tarif'] != undefined &&
                  materiel['subscription']['CAT_Tarif_GM_id::T2_Tarif'] != ''
                    ? [
                        {
                          title:
                            materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'] +
                            ' € : ' +
                            materiel['subscription']['CAT_Tarif_nom_id::libelle_plein'],
                          value: materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'],
                          type: 'T1',
                        },
                        {
                          title:
                            materiel['subscription']['CAT_Tarif_GM_id::T2_Tarif'] +
                            ' € : ' +
                            materiel['subscription']['CAT_Tarif_nom_id::libelle_reduit'],
                          value: materiel['subscription']['CAT_Tarif_GM_id::T2_Tarif'],
                          type: 'T2',
                        },
                      ]
                    : [
                        {
                          title:
                            materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'] +
                            ' € : ' +
                            materiel['subscription']['CAT_Tarif_nom_id::libelle_plein'],
                          value: materiel['subscription']['CAT_Tarif_GM_id::T1_Tarif'],
                          type: 'T1',
                        },
                      ]
                "
                hide-details
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.title.replaceAll("@@", "") }}
                  </span>
                </template>
                <template #item="{ item, props }">
                  <v-list-item
                    :key="props.key"
                    :value="props.value"
                    :active="props.active"
                    :title="null"
                    @click="props.onClick"
                  >
                    <v-list-item-title>
                      {{ item.title.replaceAll("@@", "") }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-card>
          </v-col>
        </v-col>
        <v-col align="center" v-if="materiel['price']">
          <v-btn @click="AddMat" style="color: white; background-color: green">
            Ajouter mon materiel
          </v-btn>
        </v-col>
      </v-col></v-card
    >
  </v-dialog>
  <v-dialog
    v-model="verifData.isOpen"
    width="99%"
    max-width="300"
    style="background-color: rgb(144, 164, 174, 0.5)"
  >
    <div>
      <v-card>
        <v-col align="center" style="font-weight: bold">
          {{ verifData.title }}
          <div
            v-if="verifData.subTitle && verifData.subTitle.length > 0"
            style="font-size: 12px; color: red"
          >
            {{ verifData.subTitle }}
          </div>
        </v-col>
        <v-col>
          <v-row align="center" justify="center">
            <v-col align="center">
              <v-btn color="red" style="color: white" @click="verifData.isOpen = false">
                Non
              </v-btn>
            </v-col>
            <v-col align="center">
              <v-btn color="green" style="color: white" @click="verifData.callBack">
                Oui
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </div>
  </v-dialog>

  <v-dialog v-model="showPlanningDispo.model" fullscreen style="background-color: white">
    <div>
      <iframe
        style="
          height: calc(100vh - 45px);
          width: 100%;
          visibility: visible;
          border: none;
          overflow: hidden;
        "
        :src="showPlanningDispo.url"
      ></iframe>
      <v-btn
        @click="showPlanningDispo.model = false"
        color="red"
        style="
          color: white;
          width: 90vw;
          position: absolute;
          bottom: 5px;
          left: 5vw;
          height: 30px;
        "
      >
        Fermer
      </v-btn>
    </div>
  </v-dialog>
  <v-dialog v-model="isReplaceMaterielOpenVerif" max-width="300">
    <v-card>
      <v-col class="pb-1" style="font-size: 20px" align="center">
        Valider ma modification
      </v-col>
      <v-col>
        <v-row justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn
              @click="
                isReplaceMaterielOpen = true;
                isReplaceMaterielOpenVerif = false;
              "
              color="#F44336"
              style="color: white"
            >
              Non
            </v-btn>
          </v-col>
          <v-col cols="6" align="center">
            <v-btn @click="changeMatricule" color="#4CAF50" style="color: white">
              Oui
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="isReplaceMaterielOpen" max-width="500">
    <v-card>
      <v-col class="pb-1" style="font-size: 20px">
        Sélectionner un nouveau matricule
      </v-col>
      <v-col>
        <v-autocomplete
          hide-details
          no-data-text="Aucun matricule trouvé"
          label="Matricule sélectionné"
          v-model="selectedMatricule"
          :items="parcListe"
          item-value="MATRICULE"
          item-title="MATRICULE"
        >
        </v-autocomplete>
      </v-col>
      <v-col class="pt-1" align="center">
        <v-btn
          color="#4CAF50"
          style="color: white"
          @click="
            isReplaceMaterielOpen = false;
            isReplaceMaterielOpenVerif = true;
          "
        >
          Valider la modification
        </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogData.value" width="auto">
    <v-card>
      <v-col class="pb-0">
        <div class="pa-2" style="font-weight: bold">
          {{ dialogData.label }}
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-row justify="center" align="center">
          <v-col cols="auto">
            <v-btn color="green" @click="dialogData.callBack"> Oui </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn color="red" @click="dialogData.value = false"> Non </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>

  <v-dialog v-model="isClotureValidation" width="auto">
    <v-card>
      <v-col class="pb-0">
        <div class="pa-2" style="font-weight: bold">
          Valider la clôture de mon contrat ?
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-row justify="center" align="center">
          <v-col cols="auto">
            <v-btn color="green" @click="cloturerContrat"> Oui </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn color="red" @click="isClotureValidation = false"> Non </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showAllOptions" max-width="800" width="99%" persistent>
    <v-card>
      <v-col style="font-weight: bold" class="pb-2">
        Options avancées
        <v-btn
          icon
          density="compact"
          style="position: absolute; right: 10px; top: 5px"
          color="red"
          @click="showAllOptions = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-divider></v-divider>
      <v-col>
        <v-row justify="center" align="center">
          <v-col class="" cols="auto">
            <v-tooltip location="top" no-click-animation>
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <v-btn
                    :disabled="getSortieState.nbrSortie <= 0"
                    @click="setDialogData('Renouveller de mon contrat', renewContrat)"
                    variant="flat"
                    color="#4CAF50"
                    style="color: white"
                  >
                    renouveler contrat
                  </v-btn>
                </div>
              </template>
              <div style="color: white">
                Le renouvellement n'est possible uniquement si au moins un matériel est en
                sortie.
              </div>
            </v-tooltip>
          </v-col>
          <v-col class="" cols="auto">
            <!-- <v-btn
              color="#D32F2F"
              style="color: white; width: 100%"
              variant="flat"
              @click="isClotureValidation = true"
            >
              Clôturer le contrat
            </v-btn> -->
            <v-tooltip location="top" no-click-animation>
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <v-btn
                    :disabled="getSortieState.nbrSortie > 0"
                    @click="isClotureValidation = true"
                    variant="flat"
                    color="#D32F2F"
                    style="color: white"
                  >
                    Clôturer le contrat
                  </v-btn>
                </div>
              </template>
              <div style="color: white">
                La clôture d’un contrat est impossible si un matériel est encore en
                sortie.
              </div>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-card style="height: 100vh; overflow: auto">
    <v-col v-if="!isLoading" style="font-weight: bold !important" class="sav-contrat">
      <v-col class="px-0">
        <v-card
          variant="flat"
          style="border: solid 5px"
          :style="{ 'border-color': isEdited ? 'red' : 'transparent' }"
          color="#FAFAFA"
        >
          <v-chip
            v-if="isEdited"
            style="
              position: fixed;
              top: 32px;
              right: 50px;
              z-index: 2;
              background-color: rgb(255, 0, 0, 0.8);
              color: white;
              font-weight: bold;
              font-size: 13px;
            "
          >
            Des modifications ont été apportées, les valider pour continuer
          </v-chip>
          <v-chip
            v-if="!isEditable"
            style="
              position: fixed;
              top: 32px;
              right: 50px;
              z-index: 2;
              background-color: rgb(255, 0, 0, 0.8);
              color: white;
              font-weight: bold;
              font-size: 10px;
            "
          >
            Contrat facturé et plus modifiable
          </v-chip>
          <v-col>
            <v-row>
              <v-col cols="auto">
                <div>
                  Contrat :
                  <span style="font-weight: bold">{{
                    localContrat["N° Contrat Comp"]
                  }}</span>
                </div>
              </v-col>
              <v-col cols="auto">
                <div>
                  Code client :
                  <span style="font-weight: bold">{{ localContrat["Code client"] }}</span>
                </div>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row>
              <v-col align="center">
                <table class="table" style="width: 100%">
                  <tr v-for="(elem, idx) in dataToShow" :key="idx">
                    <td
                      class="table-line"
                      :style="{
                        'background-color': idx % 2 != 0 ? 'white' : 'rgb(236, 239, 241)',
                      }"
                    >
                      {{ elem.label }}
                    </td>
                    <td
                      class="table-line"
                      :style="{
                        'background-color': idx % 2 != 0 ? 'white' : 'rgb(236, 239, 241)',
                      }"
                    >
                      <div v-if="elem.key == 'LocdataS_::Date Debut Loc'">
                        <div v-if="elem.editable">
                          <v-card variant="flat">
                            <input
                              @change="isEdited = true"
                              type="date"
                              v-model="localContrat['LocdataS_::Date Debut Loc']"
                              style="
                                width: 100%;
                                padding: 15px;
                                border: solid 1px lightgrey;
                                border-radius: 5px;
                              "
                            />
                          </v-card>
                        </div>
                        <div v-else>
                          {{ formatDate(localContrat[elem.key], "DD/MM/YYYY") }}
                        </div>
                      </div>
                      <div v-else-if="elem.key == 'Caution_montant_saisie'">
                        <span v-if="localContrat[elem.key] == undefined">0 €</span>
                        <span v-else> {{ localContrat[elem.key] }}€ </span>
                      </div>
                      <div v-else-if="elem.key == 'LocdataS_::Date retour'">
                        {{ formatDate(localContrat[elem.key], "DD/MM/YYYY") }}
                      </div>
                      <div v-else>
                        <v-select
                          variant="outlined"
                          bg-color="white"
                          hide-details
                          v-if="elem.key == 'Lieu_retrait_nom' && elem.editable"
                          item-value="PR_NOM_AG"
                          @update:modelValue="isEdited = true"
                          v-model="localContrat.Lieu_retrait_nom"
                          :items="retraitListe"
                          item-title="PR_NOM_AG"
                        ></v-select>
                        <div v-else>
                          {{ localContrat[elem.key] }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-col
              v-if="options && options.find((val) => val.name == 'paiement_proposition')"
              class="px-0"
            >
              <v-card
                style="border: solid 2px #9e9e9e; border-radius: 0px"
                variant="flat"
                class="pa-2"
              >
                <v-col cols="12"> Paiement effectué par... </v-col>
                <v-select
                  :readonly="!isEditable"
                  @update:modelValue="isEdited = true"
                  hide-details
                  variant="outlined"
                  elevation="0"
                  v-model="localContrat.reglement_mode_prevu"
                  :bg-color="isEditable ? 'rgb(239, 154, 154)' : 'white'"
                  :items="
                    [{ title: 'En attente de paiement' }].concat(
                      options.find((val) => val.name == 'paiement_proposition').value
                    )
                  "
                >
                </v-select>
              </v-card>
            </v-col>
            <v-col
              v-if="options && options.find((val) => val.name == 'caution_proposition')"
              class="px-0"
            >
              <v-card
                style="border: solid 2px #9e9e9e; border-radius: 0px"
                variant="flat"
                class="pa-2"
              >
                <v-col cols="12"> Caution effectué par... </v-col>
                <v-select
                  :readonly="!isEditable"
                  @update:modelValue="isEdited = true"
                  hide-details
                  variant="outlined"
                  v-model="localContrat['caution_multiple::type_caution']"
                  elevation="0"
                  :bg-color="isEditable ? 'rgb(239, 154, 154)' : 'white'"
                  :items="
                    [{ title: 'En attente de caution', value: '' }].concat(
                      options.find((val) => val.name == 'caution_proposition').value
                    )
                  "
                >
                </v-select>
              </v-card>
            </v-col>
            <v-col class="px-0" v-if="pjListe && pjListe.length > 0">
              <v-card
                style="border: solid 2px #9e9e9e; border-radius: 0px"
                variant="flat"
                class="pa-2"
              >
                <v-col cols="12"> Pièce justificatif </v-col>
                <v-col>
                  <v-row>
                    <v-col v-for="pj in pjListe" :key="pj.nom" cols="12" class="pa-1">
                      <v-card color="#EEEEEE" variant="flat">
                        <v-col class="pa-2">
                          <v-row justify="center" align="center">
                            <v-col cols="pa-0">
                              <v-card variant="flat">
                                <v-file-input
                                  :disabled="!isEditable"
                                  v-model="filesData[pj.nom]"
                                  density="compact"
                                  variant="solo"
                                  style="width: 100%"
                                  accept="image/*, application/pdf"
                                  :label="pj.libelle"
                                  prepend-icon=""
                                  @change="validateFile(pj)"
                                  hide-details
                                >
                                </v-file-input
                              ></v-card>
                            </v-col>
                            <v-col cols="auto" class="">
                              <div v-if="fileExiste.includes(pj.nom)">
                                <v-chip
                                  style="
                                    border-radius: 5px;
                                    color: var(--C3);
                                    background-color: green;
                                    color: white;
                                  "
                                  variant="tonal"
                                  >Document enregistré</v-chip
                                >
                                <v-btn
                                  class="ml-2"
                                  @click="downloadFile(pj.nom)"
                                  :icon="'mdi-download'"
                                >
                                </v-btn>
                              </div>
                              <div v-else>
                                <v-chip
                                  style="
                                    border-radius: 5px;
                                    color: var(--C3);
                                    background-color: red;
                                    color: white;
                                  "
                                  variant="tonal"
                                  >Document non enregistré</v-chip
                                >
                              </div>
                              <!-- <v-row v-if="fileExiste[pj.nom]" align="center">
                                <v-col align="left" cols="" @click="uploadFile(pj.nom)">
                                  <v-chip
                                    style="border-radius: 5px; color: var(--C3)"
                                    variant="tonal"
                                    >Document enregistré</v-chip
                                  >
                                </v-col>
                                <v-col align="left" cols="auto" class="">
                                  <v-btn
                                    @click="
                                      downloadFile(
                                        pj.nom,
                                        isUploadFileOpen.contratData[
                                          'Contrat Loc::numero_reservation'
                                        ]
                                      )
                                    "
                                    :icon="'mdi-download'"
                                  >
                                  </v-btn>
                                </v-col>
                              </v-row>
                              <div v-else class="pa-3" @click="uploadFile(pj.nom)">
                                <v-chip
                                  style="border-radius: 5px"
                                  variant="tonal"
                                  >Document non enregistré
                                </v-chip>
                              </div>-->
                            </v-col>
                          </v-row>
                        </v-col></v-card
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <!-- <v-col>
                <v-btn @click="uploadFiles()">
                Envoyer les fichier</v-btn></v-col> -->
              </v-card>
            </v-col>
            <!-- <v-col
              v-if="
                isEdited == false &&
                isEditable &&
                getSortieState.allSortie &&
                localContrat &&
                localContrat.reglement_mode_prevu &&
                localContrat.reglement_mode_prevu.length > 0 &&
                localContrat['caution_multiple::type_caution'] &&
                localContrat['caution_multiple::type_caution'].length > 0
              "
              class="px-0"
            >
              <v-btn
                variant="flat"
                @click="sendToFacturation"
                color="#E57373"
                style="color: white; width: 100%; border: solid 2px red"
              >
                Facturer
              </v-btn>
            </v-col> -->
            <v-col class="px-0" v-if="isEdited == false">
              <v-card
                style="border: solid 2px #9e9e9e; border-radius: 0px"
                variant="flat"
                class="pa-2"
              >
                <v-col cols="12"> Location(s) </v-col>
                <v-col v-for="(elem, idx) in matriculListe" :key="idx">
                  <v-card
                    variant="flat"
                    style="border: solid 1px lightgrey"
                    color="#F5F5F5"
                  >
                    <!-- :items="parcListe.filter((val) => val.SOUS_FAMILLE == elem.CLD_SOUS_FAMILLE)" -->
                    <!-- <v-btn
                      density="compact"
                      color="red"
                      style="z-index: 5; position: absolute; right: 0px; top: 0px"
                      icon="mdi-minus-thick"
                      @click="removeMat(elem)"
                    ></v-btn> -->
                    <v-tooltip location="top" no-click-animation>
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-btn
                            v-if="
                              !isEditable ||
                              elem.CLD_STATUT == 'Sortie' ||
                              elem.CLD_STATUT == 'Rentré'
                            "
                            density="compact"
                            variant="flat"
                            style="z-index: 5; position: absolute; right: 3px; top: 3px"
                            icon="mdi-minus-thick"
                            readonly
                            color="grey"
                          >
                          </v-btn>
                          <v-btn
                            v-else
                            density="compact"
                            color="red"
                            variant="flat"
                            style="z-index: 5; position: absolute; right: 3px; top: 3px"
                            icon="mdi-minus-thick"
                            @click="removeMat(elem)"
                          ></v-btn>
                        </div>
                      </template>
                      <div style="color: white">
                        Pour supprimer un matériel, le contrat ne doit pas être facturé ni
                        clôturé, et le matériel ne doit être ni en sortie ni en entrée.
                      </div>
                    </v-tooltip>

                    <div class="pa-3">
                      <v-card
                        variant="flat"
                        style="border: solid 1px lightgrey"
                        class="pa-4"
                        align="center"
                      >
                        {{ "Matricule - " + elem.CLD_MATRICULE }} /
                        {{ "Famille - " + elem.CLD_SOUS_FAMILLE }}
                        <!-- <v-select
                          variant="solo"
                          :readonly="!isEditable || elem.CLD_STATUT != 'En attente'"
                          item-value="MATRICULE"
                          item-title="MATRICULE"
                          :items="parcListe"
                          hide-details
                          :label="'Matricule - ' + elem.CLD_SOUS_FAMILLE"
                          v-model="elem.CLD_MATRICULE"
                          @update:modelValue="matriculeChange(elem)"
                          no-data-text="Aucun matricule trouvé"
                          :bg-color="isEditable ? 'rgb(239, 154, 154)' : 'lightgrey'"
                        >
                        </v-select> -->
                      </v-card>
                    </div>
                    <v-col
                      v-if="matriculIsFree[elem.CLD_MATRICULE]"
                      class="pb-0"
                      align="center"
                    >
                      <div
                        v-if="
                          matriculIsFree[elem.CLD_MATRICULE].data.disponible == 'false'
                        "
                      >
                        <v-chip color="red" style="font-weight: bold">
                          Le {{ elem.CLD_MATRICULE }}
                          n'est pas disponible
                        </v-chip>
                      </div>
                      <div
                        v-if="
                          matriculIsFree[elem.CLD_MATRICULE].data.disponible == 'true'
                        "
                      >
                        <v-chip color="green" style="font-weight: bold">
                          Le
                          {{ elem.CLD_MATRICULE }}
                          est disponible
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col class="pb-0" align="center">
                      <v-row>
                        <v-col>
                          <v-btn
                            variant="flat"
                            style="width: 100%"
                            @click="
                              elem.CLD_STATUT != 'En attente'
                                ? setAction(elem, {
                                    title: 'Annuler la sortie',
                                    value: 'attenteMateriel',
                                  })
                                : ''
                            "
                            :style="
                              elem.CLD_STATUT == 'En attente'
                                ? 'color: white;background-color: #1A237E;'
                                : 'border:solid 1px lightgrey'
                            "
                            >En attente</v-btn
                          >
                        </v-col>
                        <v-col>
                          <v-btn
                            variant="flat"
                            style="width: 100%"
                            @click="
                              elem.CLD_STATUT != 'Sortie'
                                ? setAction(elem, {
                                    title: 'Sortir le materiel',
                                    value: 'sortirMateriel',
                                  })
                                : ''
                            "
                            :style="
                              elem.CLD_STATUT == 'Sortie'
                                ? 'color: white;background-color: #1B5E20;'
                                : 'border:solid 1px lightgrey'
                            "
                            value="Sortie"
                          >
                            Sortie</v-btn
                          >
                        </v-col>
                        <v-col>
                          <v-btn
                            variant="flat"
                            style="width: 100%"
                            @click="
                              elem.CLD_STATUT != 'Rentré'
                                ? setAction(elem, {
                                    title: 'Rentrer le materiel',
                                    value: 'rentrerMateriel',
                                  })
                                : ''
                            "
                            :style="
                              elem.CLD_STATUT == 'Rentré'
                                ? 'color: white;background-color: #B71C1C;'
                                : 'border:solid 1px lightgrey'
                            "
                            value="Retour"
                          >
                            Rentré</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="px-0 pb-1 pt-4" align="center">
                      <v-chip style="font-weight: bold">
                        Réservation :
                        {{
                          getContartDureById[elem.CLD_ID_DUREE_LOCATION][
                            "CAT_Tarif_GM_id::Nom_Grille"
                          ]
                        }}
                      </v-chip>
                    </v-col>
                    <!-- <v-col class="px-0">
                      <v-row justify="left" align="left"> -->
                    <!-- <v-col cols="">
                                                    <v-autocomplete variant="outlined" label="Sélectionner une action"
                                                        class="edition" return-object="" hide-details
                                                        v-model="actionData[elem.CLD_MATRICULE]" :items="actionListe">
                                                    </v-autocomplete>
                                                </v-col> -->
                    <v-col cols="auto" align="left" class="pt-0">
                      <v-btn
                        style="text-transform: none"
                        variant="flat"
                        color="green"
                        @click="
                          verifData = {
                            isOpen: true,
                            title: 'Envoyer vers état des lieux',
                            callBack: function () {
                              elem.CLD_CONTROLE_DEPART = 0;
                              elem.CLD_CONTROLE_RETOUR = 0;
                              envoyerMatEtadtdl(elem);
                            },
                          }
                        "
                      >
                        Envoyer vers état des lieux
                        <!-- {{ actionData.function.title }} - {{
                                                    actionData.matricul.CLD_MATRICULE }} -->
                      </v-btn>
                      <div
                        class="py-2"
                        align=""
                        v-if="
                          (elem.CLD_CONTROLE_DEPART !== '' &&
                            elem.CLD_CONTROLE_DEPART >= 0) ||
                          (elem.CLD_CONTROLE_RETOUR !== '' &&
                            elem.CLD_CONTROLE_RETOUR >= 0)
                        "
                        style="color: red; font-size: 12px"
                      >
                        État des lieux déjà envoyé
                      </div>
                    </v-col>
                    <v-col cols="auto" align="left" class="pt-0">
                      <v-btn
                        style="text-transform: none"
                        variant="flat"
                        color="green"
                        @click="
                          verifData = {
                            isOpen: true,
                            title: 'Envoyer vers OR',
                            callBack: function () {
                              envoyerMatOr(elem);
                            },
                          }
                        "
                      >
                        Envoyer vers OR
                      </v-btn>
                      <div
                        class="py-2"
                        align=""
                        v-if="elem.CLD_OR_CREAT == '1'"
                        style="color: red; font-size: 12px"
                      >
                        OR déjà envoyé
                      </div>
                    </v-col>
                    <!-- </v-row>
                    </v-col> -->
                  </v-card>
                </v-col>
                <v-col align="center" v-if="isEditable">
                  <v-btn icon="mdi-plus" @click="openNewMatForm"> </v-btn>
                </v-col>
                <v-divider class="mb-3 mt-1 mx-3"></v-divider>
                <v-col cols="12" align="center" class="py-0">
                  <v-btn
                    variant="flat"
                    style="background-color: #80cbc4; color: white; width: 100%"
                    @click="
                      verifData = {
                        isOpen: true,
                        title: 'Envoyer pour signature',
                        callBack: function () {
                          envoyerMatSignature();
                        },
                      }
                    "
                  >
                    Envoyer pour signature
                    <!-- {{ actionData.function.title }} - {{
                                                    actionData.matricul.CLD_MATRICULE }} -->
                  </v-btn>
                  <div
                    align="left"
                    class="mt-1"
                    v-if="fileIsSigned"
                    style="color: red; font-size: 13px; font-weight: bold"
                  >
                    Contrat déja envoyé pour signature
                  </div>
                </v-col>
              </v-card>
            </v-col>
            <v-col class="pa-0" v-if="isEdited == false">
              <v-card
                class="pa-2"
                style="border: solid 2px #9e9e9e; border-radius: 0px"
                variant="flat"
              >
                <div class="mb-2 pt-1">Ouverture rapide :</div>
                <v-row class="">
                  <v-col cols="auto" class="pl-3 px-1">
                    <v-btn
                      variant="flat"
                      @click="
                        setIframe(
                          '/#/etat-des-lieux-materiel?search=' +
                            localContrat['N° Contrat Comp']
                        )
                      "
                      style="color: white"
                      target="_blank"
                      color="#1A237E"
                      >État des lieux</v-btn
                    >
                  </v-col>
                  <v-col cols="auto" class="px-1">
                    <v-btn
                      variant="flat"
                      @click="
                        setIframe(
                          '/#/sav-gestion?search=' + localContrat['N° Contrat Comp']
                        )
                      "
                      style="color: white"
                      target="_blank"
                      color="#66BB6A"
                      >SAV</v-btn
                    >
                  </v-col>
                  <v-col cols="auto" class="px-1">
                    <v-btn
                      variant="flat"
                      @click="
                        setIframe(
                          '/#/signature-en-ligne?search=' + localContrat['Code client']
                        )
                      "
                      color="#A1887F"
                      style="color: white"
                      target="_blank"
                      >Signature des documents</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col
              align="center"
              v-if="isEdited == true"
              style="position: fixed; bottom: 0vh"
              class="mt-4"
            >
              <v-btn
                color="#4CAF50"
                :disabled="!isEdited"
                style="color: white"
                variant="flat"
                @click="updateContrat"
              >
                Valider mes modifications
              </v-btn>
            </v-col>
          </v-col>
        </v-card>
      </v-col>
      <v-col v-if="isEdited == false">
        <v-row>
          <v-col class="" cols="auto" v-if="isEditable">
            <v-tooltip location="top" no-click-animation>
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <v-btn
                    :disabled="
                      localContrat.reglement_mode_prevu == undefined ||
                      localContrat.reglement_mode_prevu.length == 0 ||
                      localContrat['caution_multiple::type_caution'] == undefined ||
                      localContrat['caution_multiple::type_caution'].length == 0 ||
                      matriculListe.filter((val) => val.CLD_STATUT != 'Sortie').length !=
                        0
                    "
                    @click="
                      setDialogData(
                        'Valider la facturation de mon contrat',
                        sendToFacturation
                      )
                    "
                    variant="flat"
                    color="#E57373"
                    style="color: white"
                  >
                    Facturer
                  </v-btn>
                </div>
              </template>
              <div style="color: white">
                La facturation n’est possible que si le mode de paiement <br />
                et la caution sont valides, et si l’ensemble des matériels ont été sortis
              </div>
            </v-tooltip>
          </v-col>
          <v-col class="" cols="auto">
            <v-btn
              variant="flat"
              @click="showAllOptions = true"
              color="#5C6BC0"
              style="color: white"
            >
              Options avancées
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
    <div
      v-else
      align="center"
      style="background-color: #eceff1; height: 100vh; padding-top: 35vh"
    >
      <v-progress-circular :size="180" :width="4" color="primary" indeterminate>
        Chargement
      </v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import engine from "../core/DataApi";
// import DataApi from "../core/DataApi";

export default {
  props: {
    get_user_information: {},
    familyListe: {},
    subFamilyListe: {},
    agencyListe: {},
    seletedContrat: {},
    parcListe: {},
    options: {},
    contrat_informations: {},
    retraitListe: {},
    openContratByNum: { type: Function },
    setMessage: { type: Function },
    getContratsListe: { type: Function },
    closeEdition: { type: Function },
  },
  // watch: {
  //   selectedCaution() {
  //     engine.update_caution(this.localContrat.ID, "modeDepot", "montant", function () {});
  //   },
  // },
  data() {
    return {
      dialogData: {},
      selectedSubFamilyData: undefined,
      materiel: {},
      newMatFormIsOpen: false,
      fileIsSigned: false,
      verifData: {},
      pjChanged: false,
      fileExiste: [],
      filesData: {},
      pjListe: [],
      recordId: undefined,
      showAllOptions: false,
      isClotureValidation: false,
      actionData: {},
      // actionListe: [
      //   // { title: 'Sortir le materiel', value: 'sortirMateriel' },
      //   // { title: 'Annuler la sortie', value: 'attenteMateriel' },
      //   // { title: 'Rentrer le materiel', value: 'rentrerMateriel' },
      //   { title: "Envoyer vers etat des lieux", value: "envoyerMatEtadtdl" },
      //   { title: "Envoyer pour signature", value: "envoyerMatSignature" },
      //   // { title: 'Envoyer pour OR/OP', value: 'envoyerMatOr' },
      // ],
      isLoading: false,
      isEdited: false,
      matriculListe: undefined,
      savedMatriculListe: undefined,
      localContrat: {},
      // selectedCaution: undefined,
      showPlanningDispo: {},
      matriculIsFree: {},
      isReplaceMaterielOpenVerif: false,
      isReplaceMaterielOpen: false,
      editableKey: ["LocdataS_::N° Mat interne"],
      editableData: {},
    };
  },
  methods: {
    reloadContrat() {
      let that = this;
      that.isLoading = true;
      that.getContratsListe(function () {
        that.getContratFormatedData(that.localContrat);
        that.isEdited = false;
        that.isLoading = false;
      });
    },
    removeMat(mat) {
      let that = this;
      let matData = {
        CLD_ID_CONTRAT_LOC_DATA: mat["CLD_ID_CONTRAT_LOC_DATA"],
      };

      // let that = this;
      this.dialogData = {
        value: true,
        label: "Valider la suppression de materiel ?",
        callBack: function () {
          that.isLoading = true;
          that.dialogData.value = false;
          engine.delete_mat(matData, function (data) {
            console.log("delete_mat", data);
            that.reloadContrat();

            // that.getMatriculListeData(function () {
            //   that.isLoading = false;
            // });
          });
        },
      };
    },
    setDialogData(label, callBack) {
      let that = this;
      this.dialogData = {
        value: true,
        label,
        callBack: function () {
          that.dialogData.value = false;
          callBack();
        },
      };
    },
    AddMat() {
      let that = this;
      let matData = {
        CLD_CONTROLE_DEPART: "",
        CLD_CONTROLE_RETOUR: "",
      };

      matData["CLD_NUM_CONTRAT"] = this.localContrat["N° Contrat Comp"];
      matData["CLD_TARIF"] = this.materiel["price"].type;
      matData["CLD_MATRICULE"] = this.materiel["materiel"]["MATRICULE"];
      matData["CLD_DESCRIPTION"] = this.materiel["family"]["WEB_NOM_FAMILLE"];
      matData["CLD_SOUS_FAMILLE"] = this.materiel["materiel"]["SOUS_FAMILLE"];

      matData["CLD_ID_DUREE_LOCATION"] = this.materiel["subscription"][
        "CAT_Tarif_GM_id::ID_Grille"
      ];
      matData["CLD_DATE_DEPART"] = this.localContrat["LocdataS_::Date contrat"];
      matData["CLD_DATE_RETOUR"] = this.localContrat["LocdataS_::Date retour"];

      matData["CLD_ID_SOCIETE"] = this.get_user_information.user_id_societe;
      matData["CLD_ID_WEB"] = ""; //Pas d'ID si créer sur ACCEN de base
      // matData["CLD_ID_CONTRAT_WEB"] = "";
      // matData["CLD_ID_CLIENT"] = ""; // code client c'est bon ?
      // matData["CLD_ID_LIEU_RETRAIT"] = "";
      // matData["CLD_ID_AGENCE"] = "";
      // matData["CLD_NOM_CLIENT"] = this.localContrat["Societe"];

      //         <!-- [
      //     {
      //         "CLD_CONTROLE_DEPART": "",
      //         "CLD_CONTROLE_RETOUR": "",
      //         "CLD_TARIF": "T1",
      //         "CLD_MATRICULE": "VC1101",
      //         "CLD_DATE_DEPART": "08/25/2025",
      //         "CLD_DATE_RETOUR": "08/25/2025",
      //         "CLD_DESCRIPTION": "VÉLO classique et électrique",
      //         "CLD_ID_SOCIETE": "13",
      //         "CLD_ID_CONTRAT_WEB": "915e3c5f-b93d-40c5-bffb-e21a0f46b2c9",
      //         "CLD_ID_WEB": "d8d77de4-c807-4586-88ae-15a3191c07c0",
      //         "CLD_ID_CLIENT": "C9102",
      //         "CLD_ID_LIEU_RETRAIT": 61,
      //         "CLD_ID_AGENCE": 61,
      //         "CLD_ID_DUREE_LOCATION": "94025001-1191-174F-891A-07F89A688551",
      //         "CLD_SOUS_FAMILLE": "VELO",
      //         "CLD_NOM_CLIENT": "test accen"
      //     }
      // ] -->

      console.log("matData", matData);

      // engine.creat_contrat([matData], function (data) {
      //   console.log("creat_contrat", data);

      //   if (data.code == 0) {
      //     console.log("scriptResult2", data.data.data.scriptResult);
      //   }
      // });

      that.newMatFormIsOpen = false;
      that.isLoading = true;
      engine.add_mat([matData], function (data) {
        console.log("creat_contrat", data);

        if (data.code == 0) {
          console.log("scriptResult2", data.data.data.scriptResult);
        }
        that.reloadContrat();
      });
    },
    changeSubFamily(subFamily) {
      let that = this;

      engine.get_sub_family_info(subFamily.fieldData.Nom_Genre_Machine, function (data) {
        that.selectedSubFamilyData = data.data.data[0];
        console.log("selectedSubFamilyData", that.selectedSubFamilyData);
      });
    },
    openNewMatForm() {
      this.newMatFormIsOpen = true;
    },
    isFileSigned() {
      let that = this;
      this.fileIsSigned = false;
      engine.getSignedFileData(
        this.localContrat["N° Contrat Comp"],
        this.localContrat["Code client"],
        function (data) {
          if (data.code == 0 && data.data.data.data[0].fieldData) {
            that.fileIsSigned = true;
          } else that.fileIsSigned = false;
        }
      );
    },
    verifIfFileExiste() {
      console.log("verifIfFileExiste", this.localContrat);
      // engine.File_Exist(
      //   that.pjListe[i].nom,
      //   that.localContrat["Code client"] +
      //     "/" +
      //     that.localContrat["numero_reservation"] +
      //     "/documents",
      //   // that.localContrat["N° Contrat Comp"] +
      //   function (res) {
      //     if (res && res.data) {
      //       console.log("File_Exist", that.pjListe[i].nom);
      //       that.fileExiste.push(that.pjListe[i].nom);
      //     }
      //   }
      // );
      return true;
    },
    getContratFormatedData(contratData) {
      this.setData(contratData);
      this.getMatriculListeData();
      this.getPjListe();
    },
    downloadFile(key) {
      // let folderPath =
      //   this.localContrat["Code client"] +
      //   "/" +
      //   this.localContrat["N° Contrat Comp"] +
      //   "/documents";

      let folderPath =
        this.localContrat["Code client"] +
        "/" +
        this.localContrat["numero_reservation"] +
        "/documents";

      engine.File_download_from_path(folderPath, key, function (data) {
        if (data.code == 0) {
          window.location.href = data.data.url;
        }
      });
    },
    updateFiles() {
      this.uploadFiles(
        this.isUploadFileOpen.contratData["Contrat Loc::numero_reservation"]
      );
      this.isUploadFileOpen = {
        model: false,
        data: [],
        contratData: {},
      };
      this.fileLoadedData = [];
      this.snackbar = {
        model: true,
        color: "green",
        value: "Documents enregistré",
      };
    },

    async uploadFiles() {
      let that = this;
      // let folder = this.localContrat["N° Contrat Comp"];
      let folder = this.localContrat["numero_reservation"];

      if (this.pjChanged) {
        engine.update_info_file_uploaded(
          this.localContrat["N° Contrat Comp"],
          function () {}
        );
      }

      for (const [key, file] of Object.entries(that.filesData)) {
        if (file && file[0]) {
          let bas64 = await this.getBase64(file[0]);
          let extension = file[0].name.split(".");
          extension = extension[extension.length - 1];
          let name = key + "." + extension;

          engine.File_Upload(
            this.localContrat["Code client"],
            folder + "/documents/",
            name,
            bas64,
            function () {
              that.filesData[key] = undefined;
              that.getPjListe();
            }
          );
        }
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function () {
          reject("");
        };
      });
    },
    validateFile(key) {
      this.isEdited = true;
      this.pjChanged = true;
      if (!this.filesData[key]) {
        this.errorMessage = "Un document est requis.";
        return;
      }

      if (this.filesData[key].size > this.maxFileSize) {
        this.errorMessage = `La taille des documents doit être inférieure à 1Mo.`;
        this.filesData[key] = null; // Réinitialiser le document sélectionné
      } else {
        this.errorMessage = ""; // Aucun message d'erreur
      }
    },
    getPjListe() {
      let that = this;
      this.pjListe = [];
      engine.get_contrat_pj(
        this.localContrat["LocdataS_::ID_GenreMachne"],
        function (data) {
          if (data.code == 0) {
            that.pjListe = data.data.data.map((val) => val.fieldData);
            for (let i = 0; i < that.pjListe.length; i++) {
              let path =
                that.localContrat["Code client"] +
                "/" +
                that.localContrat["numero_reservation"] +
                "/documents";
              console.log("path", path);

              engine.File_Exist(
                that.pjListe[i].nom,
                path,
                // that.localContrat["N° Contrat Comp"] +
                function (res) {
                  if (res && res.data) {
                    console.log("File_Exist", that.pjListe[i].nom);
                    that.fileExiste.push(that.pjListe[i].nom);
                  }
                }
              );
            }
          }
        }
      );
    },
    getMatriculListeData(callback) {
      console.log("getMatriculListeData");

      let that = this;
      that.matriculListe = [];
      that.savedMatriculListe = [];

      engine.get_contrat_matricul_liste(
        this.localContrat["N° Contrat Comp"],
        function (data) {
          console.log("get_contrat_matricul_liste", data);

          if (data.code == 0) {
            that.recordId = data.data.data[0].recordId;
            that.matriculListe = JSON.parse(
              JSON.stringify(data.data.data.map((val) => val.fieldData))
            );
            that.savedMatriculListe = JSON.parse(
              JSON.stringify(data.data.data.map((val) => val.fieldData))
            );
          }
          if (callback) callback();
        }
      );
    },
    setAction(mat, funct) {
      this.actionData[mat.CLD_MATRICULE] = funct;
      this.runAction(mat);
    },
    setData(contratData) {
      this.localContrat = JSON.parse(JSON.stringify(contratData));
      if (this.localContrat["LocdataS_::N° Mat interne"])
        this.selectedMatricule = JSON.parse(
          JSON.stringify(this.localContrat["LocdataS_::N° Mat interne"])
        );
      if (this.localContrat["LocdataS_::Date Debut Loc"])
        this.localContrat["LocdataS_::Date Debut Loc"] = moment(
          this.localContrat["LocdataS_::Date Debut Loc"]
        ).format("yyyy-MM-DD");
    },
    runAction(mat) {
      let that = this;
      that.isLoading = true;
      that.showAllOptions = false;

      this[this.actionData[mat.CLD_MATRICULE].value](mat, function () {
        that.getContratsListe(function () {
          that.getMatriculListeData(function () {
            that.isLoading = false;
          });
        });
      });
    },
    testFunction(mat, callback) {
      console.log("testFunction", mat);
      callback();
    },
    sortirMateriel(mat, callback) {
      engine.sortie_mat(mat.CLD_ID_CONTRAT_LOC_DATA, function () {
        callback();
      });
    },
    rentrerMateriel(mat, callback) {
      engine.retour_mat(mat.CLD_ID_CONTRAT_LOC_DATA, function () {
        callback();
      });
    },
    cloturerContrat() {
      let that = this;
      that.isLoading = true;
      that.isClotureValidation = false;
      that.showAllOptions = false;
      engine.cloture_contrat(this.localContrat["N° Contrat Comp"], function () {
        that.getContratsListe(function () {
          that.closeEdition();
        });
      });
    },
    attenteMateriel(mat, callback) {
      engine.cancel_mat(mat.CLD_ID_CONTRAT_LOC_DATA, function () {
        callback();
      });
    },
    envoyerMatEtadtdl(mat, callback) {
      this.isLoading = true;
      let that = this
      this.verifData.isOpen = false;

      engine.send_mat_etadl(mat.CLD_ID_CONTRAT_LOC_DATA, function () {
        callback();
          that.updateContrat()
      });
    },
    envoyerMatSignature() {
      this.verifData.isOpen = false;
      this.fileIsSigned = true;
      engine.send_to_signe(this.localContrat["N° Contrat Comp"], function () {});
    },

    envoyerMatOr(mat, callback) {
      this.isLoading = true;
      this.verifData.isOpen = false;
      let that = this

      engine.send_mat_or(
        mat.CLD_MATRICULE,
        mat.CLD_NUM_CONTRAT,
        mat.CLD_ID_CONTRAT_LOC_DATA,
        "",
        function () {
          if (callback) callback();
          that.updateContrat()
        }
      );
    },
    sendToFacturation() {
      let that = this;

      that.isLoading = true;
      that.showAllOptions = false;

      engine.facturation(
        this.localContrat["N° Contrat Comp"],
        this.get_user_information.identifiant_accen,
        function () {
          that.getContratsListe(function () {
            that.isLoading = false;
            that.closeEdition();
          });
        }
      );
    },
    updateContrat() {
      let that = this;
      this.isLoading = true;
      this.uploadFiles();
      this.localContrat["LocdataS_::Date Debut Loc"] = moment(
        this.localContrat["LocdataS_::Date Debut Loc"]
      ).format("MM/DD/YYYY");

      for (let i = 0; i < that.savedMatriculListe.length; i++) {
        if (
          that.savedMatriculListe[i].CLD_MATRICULE != that.matriculListe[i].CLD_MATRICULE
        ) {
          if (that.savedMatriculListe[i].CLD_STATUT == "En attente") {
            engine.update_contrat_from_SSynch(
              that.matriculListe[i].CLD_ID_WEB,
              that.matriculListe[i].CLD_MATRICULE,
              function () {}
            );
          } else {
            engine.change_matricule(
              that.savedMatriculListe[i]["CLD_NUM_CONTRAT"],
              that.savedMatriculListe[i]["CLD_ID_CONTRAT_LOC_DATA"],
              that.savedMatriculListe[i].CLD_MATRICULE,
              that.matriculListe[i].CLD_MATRICULE,
              function () {}
            );
          }
        }
      }

      that.localContrat["LocdataS_::N° Mat interne"] =
        that.matriculListe[0]["CLD_MATRICULE"];

      engine.update_contrat(that.localContrat, function () {
        // that.closeEdition()
        that.reloadContrat();
      });
    },
    renewContrat() {
      let that = this;

      that.isLoading = true;
      that.showAllOptions = false;
      engine.renew_contrat(this.localContrat["N° Contrat Comp"], function (data) {
        that.getContratsListe(function () {
          that.isLoading = false;
          that.closeEdition(data.data.data.scriptResult);
        });
      });
    },
    setIframe(url) {
      let finalUrl = window.location.href.split("/#/")[0] + url + "&header=hide";

      this.showPlanningDispo = {
        model: true,
        url: finalUrl,
      };
    },
    matriculeChange(mat) {
      let that = this;
      let uuid = this.parcListe.find((val) => val.MATRICULE == mat.CLD_MATRICULE)
        .MATRICULE_UID;

      this.isEdited = true;

      engine.is_materiel_free({ UID: uuid }, function (data) {
        that.matriculIsFree[mat.CLD_MATRICULE] = data;
      });
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    changeMatricule() {
      this.isReplaceMaterielOpenVerif = false;
    },
  },
  computed: {
    getSortieState() {
      let nbrTotal = 0;
      let nbrSortie = 0;
      let allSortie = true;

      if (this.matriculListe)
        for (let i = 0; i < this.matriculListe.length; i++) {
          let elem = this.matriculListe[i];
          if (elem.CLD_STATUT != "Sortie") {
            allSortie = false;
          }
          if (elem.CLD_STATUT == "Sortie") {
            nbrSortie += 1;
          }
          nbrTotal += 1;
        }

      return { nbrTotal, nbrSortie, allSortie };
    },
    dataToShow() {
      let data = [
        {
          label: "Client",
          key: "Societe",
          type: "text",
          editable: false,
        },
        // {
        //     label: 'Type de contrat',
        //     key: 'LocdataS_::ID_Grille_nom',
        //     type: 'text',
        //     editable: true,
        // },
        {
          label: "Agence de retrait",
          key: "Lieu_retrait_nom",
          type: "text",
          editable: this.isEditable,
        },
        {
          label: "Date de sortie",
          key: "LocdataS_::Date Debut Loc",
          type: "date",
          format: "DD/MM/YYYY",
          editable: this.isEditable,
        },
        {
          label: "Date de retour",
          key: "LocdataS_::Date retour",
          type: "date",
          format: "DD/MM/YYYY",
          editable: false,
        },
        {
          label: "Prix location TTC (€)",
          key: "Prix Location Total_TTC",
          type: "text",
          editable: false,
        },
        {
          label: "Acompte (€)",
          key: "Acompte_final",
          type: "text",
          editable: false,
        },
        {
          label: "Caution demandée (€)",
          key: "Caution_montant_saisie",
          type: "text",
          editable: false,
        },
        {
          label: "Caution payée (€)",
          key: "caution_multiple::caution_texte",
          type: "text",
          editable: false,
        },
        {
          label: "Etat de la caution",
          key: "caution_multiple::etat_caution",
          type: "text",
          editable: false,
        },
      ];

      return data;
    },
    isEditable() {
      if (
        this.seletedContrat["N° FACT Comp"] &&
        this.seletedContrat["N° FACT Comp"].length > 0
      )
        return false;
      return true;
    },
    getContratSelectedInformations() {
      let veloSub = {};

      for (let i = 0; i < this.contrat_informations.length; i++) {
        let key = this.contrat_informations[i].fieldData.Nom_Genre_Machine;
        let value = this.contrat_informations[i].portalData.CAT_Tarif_GM_id.map(
          (val) => val
        );

        for (let a = 0; a < value.length; a++) {
          console.log("test", value[a]);
        }

        veloSub[key] = value;
      }

      return veloSub;
    },
    getContartDureById() {
      let veloSub = {};

      for (let i = 0; i < this.contrat_informations.length; i++) {
        // let key = this.contrat_informations[i].fieldData.Nom_Genre_Machine
        let value = this.contrat_informations[i].portalData.CAT_Tarif_GM_id.map(
          (val) => val
        );

        for (let a = 0; a < value.length; a++) {
          veloSub[value[a]["CAT_Tarif_GM_id::ID_Grille"]] = value[a];
        }
      }

      return veloSub;
    },
  },
  mounted() {
    this.getContratFormatedData(this.seletedContrat);
    console.log("localContrat", this.localContrat);
    // that.localContrat["numero_reservation"]
    this.isFileSigned();
  },
};
</script>

<style>
.sav-contrat .table {
  border-collapse: collapse;
  width: 100%;
  color: black;
  background-color: white;
}

.sav-contrat .table-line {
  border: solid 1px black;
  padding: 10px;
  color: black;
  background-color: white;
}
</style>
